import { render, staticRenderFns } from "./Stammauftraege.vue?vue&type=template&id=06070de0&scoped=true"
import script from "./Stammauftraege.vue?vue&type=script&lang=js"
export * from "./Stammauftraege.vue?vue&type=script&lang=js"
import style0 from "./Stammauftraege.vue?vue&type=style&index=0&id=06070de0&prod&scoped=true&lang=css"
import style1 from "./Stammauftraege.vue?vue&type=style&index=1&id=06070de0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06070de0",
  null
  
)

export default component.exports